import "./App.css";
import "./Components/mainstyle/mainstyle.css";
import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Mainadminpage from "./Components/admin/mainadminpage/mainadminpage";
import ProtectedRoute from "./Components/protect hooks/ProtectedRouteHook";
import Login from "./Components/form/login/login";
import Internet from "./Components/internet/internet";
import Layout from "./Components/Utility/layout/layout";
import ProtectedRouteHook from "./Components/protect hooks/protectLogic";
import Register from "./Components/form/register/register";
import "bootstrap/dist/css/bootstrap.min.css";
import Notfound from "./Components/notfound/notfound";
import Notifications from "./Components/notifications/notifications";
import MainTwkel from "./Components/user/tawkel/main/main";
import MainUserpage from "./Components/user/mainuserpage/mainuserpage";
import DaweManage from "./Components/user/dawe/main/main";
import Maindata from "./Components/user/maindata/main/main";
import Adminmanage from "./Components/admin/adminmanage/adminmanage";
import Emails from "./Components/admin/emails/emails";
import Subscribepackage from "./Components/admin/subscribepackage/subscribepackage";
import NotificationsAdmin from "./Components/admin/notification/notification";
import MainAjinda from "./Components/user/galasat/main/main";
import MainUser from "./Components/admin/usermanage/main/main";
import MainUserSub from "./Components/admin/usersubscrip/main/main";
import Payment from "./Components/user/sub/main/main";
import Howwork from "./Components/user/howwork/howwork";
import Helpuser from "./Components/user/help/help";
import Manageworks from "./Components/user/dawe copy/main/main";
import Privacy from "./Components/privacy/privacy";
import Forget from "./Components/form/forget/forget";

function App() {
  const [isUser, isAdmin, userData, isSubuser, isEditor] = ProtectedRouteHook();
  useEffect(() => {
    const currentVersion = "%REACT_APP_VERSION_3%";
    const cachedVersion = localStorage.getItem("appVersion");

    if (cachedVersion && cachedVersion !== currentVersion) {
      // Prompt user to refresh
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
      window.location.reload(true);
    }
    localStorage.setItem("appVersion", currentVersion);
  }, []);

  return (
    <>
      <BrowserRouter>
        <Layout
          userData={userData}
          isUser={isUser}
          isAdmin={isAdmin}
          isEditor={isEditor}>
          {/* <Fade cascade triggerOnce="false">
          <img style={{display:"flex",justifyContent:"center",margin:"0 auto"}} alt="" width={"100px"} src="a3maal.png"/>
          </Fade>
          <Fade cascade triggerOnce="false"direction="up">
        <h1 className="text-center">اجندة المحامي القضائية<h1 className="text-center">قريباً</h1></h1>
        </Fade> */}
          {navigator.onLine === false ? (
            <Internet />
          ) : (
            <Routes>
              {isUser || isAdmin ? null : (
                <>
                  <Route
                    path="/login"
                    element={<Login isUser={isUser} isAdmin={isAdmin} />}
                  />

                  <Route index element={<Register />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/forget" element={<Forget />} />
                </>
              )}

              <Route element={<ProtectedRoute auth={isUser} />}>
                <Route
                  path="/user/maintwkel"
                  element={<MainTwkel userData={userData} />}
                />
                <Route path="/user/mainuserpage" element={<MainUserpage />} />
                <Route
                  path="/user/dawemanage"
                  element={<DaweManage userData={userData} />}
                />
                <Route
                  path="/user/managework"
                  element={<Manageworks userData={userData} />}
                />
                <Route
                  path="/user/ajindamuhami"
                  element={<MainAjinda userData={userData} />}
                />
                <Route
                  path="/user/data"
                  element={<Maindata userData={userData} />}
                />
                <Route path="/user/howwork" element={<Howwork />} />
                <Route
                  path="/user/help"
                  element={<Helpuser userData={userData} />}
                />
                <Route
                  path="/user/sub"
                  element={<Payment userData={userData} />}
                />
                <Route path="/user/notifications" element={<Notifications />} />
              </Route>
              <Route element={<ProtectedRoute auth={isAdmin} />}>
                <Route
                  path="/admin"
                  element={
                    <Mainadminpage userData={userData} isAdmin={isAdmin} />
                  }
                />
                <Route path="/admin/adminmanage" element={<Adminmanage />} />
                <Route path="/admin/emails" element={<Emails />} />
                <Route
                  path="/admin/subscribepackage"
                  element={<Subscribepackage />}
                />
                <Route path="/admin/usermanagement" element={<MainUser />} />
                <Route path="/admin/usersubscribe" element={<MainUserSub />} />

                <Route
                  path="/admin/notifications"
                  element={<NotificationsAdmin />}
                />
              </Route>
              <Route element={<ProtectedRoute auth={isEditor} />}>
                <Route
                  path="/editor"
                  element={
                    <Mainadminpage userData={userData} isAdmin={isAdmin} />
                  }
                />
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "إضافة باقة" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/subscribepackage"}
                          element={<Subscribepackage />}
                        />
                      ) : null
                    )
                  : null}
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "بيانات المستخدمين" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/usermanagement"}
                          element={<MainUser />}
                        />
                      ) : null
                    )
                  : null}
                        
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "بيانات المشتركين" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/usersubscribe"}
                          element={<MainUserSub />}
                        />
                      ) : null
                    )
                  : null}
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "الايميلات" &&
                      claim.IsSelected === true ? (
                        <Route path={"/editor/emails"} element={<Emails />} />
                      ) : null
                    )
                  : null}
                {userData && userData.Claims && userData.Claims.length >= 0
                  ? userData.Claims.map((claim, idx) =>
                      claim.ClaimName === "الاشعارات" &&
                      claim.IsSelected === true ? (
                        <Route
                          path={"/editor/notifications"}
                          element={<NotificationsAdmin />}
                        />
                      ) : null
                    )
                  : null}
              </Route>
              <Route path="404" element={<Notfound />} />
              <Route
                path="*"
                element={
                  <Navigate
                    to={
                      isAdmin
                        ? "/admin"
                        : isUser
                        ? "/user/mainuserpage"
                        : "/404"
                    }
                    replace
                  />
                }
              />
            </Routes>
          )}
        </Layout>
      </BrowserRouter>
    </>
  );
}

export default App;
